{
  "available_dates": "Available dates",
  "booking_information": "Booking information",
  "choose_your_ship_one": "Ship",
  "choose_your_ship_other": "Choose your ship",
  "date": "Date",
  "explanation": "",
  "title": "Prices & availability",
  "x_th_cabin": "{{ index }}. {{ name }}"
}
